import * as React from 'react'

import { auto } from '@cloudinary/url-gen/actions/resize'
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity'

import { cld } from '../../../services/CloudinaryService'
import { Link } from '../Link'
import styles from './HorizontalCard.module.scss'
import { IHorizontalCardProps } from './HorizontalCard.types'

export const HorizontalCard = ({
  date,
  description,
  link,
  linkBlank,
  id,
  image,
  linkText,
  publisher,
  title,
}: IHorizontalCardProps) => {
  // Set the width of the image to max 300px
  const imageUrl = cld
    .image(image)
    .format('auto')
    .quality('auto')
    .resize(auto().gravity(autoGravity()).width(400).height(300))
    .toURL()

  return (
    <Link className={styles.horizontalCardWrapper} to={link} blank={linkBlank}>
      <div className={styles.imageContainer} id={id}>
        <img src={imageUrl} className={styles.image} alt={title} />
      </div>
      <div className={styles.cardBody}>
        {date && publisher && (
          <p className={styles.data}>
            {date} ✑ <b>{publisher}</b>
          </p>
        )}
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        {linkText && <p className={styles.linkText}>{linkText}</p>}
      </div>
    </Link>
  )
}
